import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'IN_PROGRESS',
        items: []
    }));

    return state.set('collections', collections);
}

export function error(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'ERROR',
        errors: action.errors
    }));

    return state.set('collections', collections);
}

export function finish(state, { id, accountId, data }) {
    let collections = state.get('collections');

    collections = collections.set(id, fromJS({
        state: 'FINISHED',
        accountId,
        items: fromJS(data.map(report => report.id))
    }));

    let items = state.get('items');

    for (let report of data) {
        items = items.set(report.id, fromJS(report));
    }

    return state
        .set('items', items)
        .set('collections', collections);
}

export function clear(state, { id }) {
    return state.set(
        'collections',
        state.get('collections').remove(id)
    );
}

